import React, { Fragment, useState } from "react";
import ImageModal from "../../Modals/ImageModal";
import Modal from "../../Modals/Modal";

type ImgRow = {
  row?: any;
  children: any;
};

const Image = (props: ImgRow) => {
  const [modalState, setModalState] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const [imgName, setImgName] = useState("");

  const row = props.row;

  const fullScreenImage = (e, row) => {
    e.stopPropagation();
    e.preventDefault();
    setImgSrc(row.url);
    setImgName(row.name);
    setModalState(true);
  };

  const onClose = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setModalState(false);
  };

  return (
    <Fragment>
      <div className="img-container">
        <img
          className="img"
          src={props.children}
          alt={imgName}
          onClick={(e) => fullScreenImage(e, row)}
        />
      </div>
      <ImageModal
        url={imgSrc}
        name={imgName}
        onClose={onClose}
        visible={modalState}
      />
    </Fragment>
  );
};

export default Image;
